/*
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import Fadeable from './Fadeable';

import vertexShader from '../shaders/Dot/Dot.vert';
import fragmentShader from '../shaders/Dot/Dot.frag';

export default class Dot extends Fadeable {
  constructor(props) {
    props = props ? props : {};
    props = Object.assign(
      {
        color: new THREE.Color(0xff0000),
        alpha: 0.0,
        renderOrder: -1,
        size: 1,
      },
      props
    );
    super(props);
    this.setup(props);
  }

  setup = props => {
    this.setupProperties(props);
    this.setupMaterial(props);
    this.setupGeometry(props);
    this.setupMesh(props);
  };

  setupProperties = props => {
    this.name = 'Dot';
  };

  setupGeometry = props => {
    this.geometry = new THREE.PlaneBufferGeometry(props.size, props.size);
  };

  setupMaterial = props => {
    this.material = new THREE.RawShaderMaterial({
      uniforms: {
        color: {
          value: props.color,
        },
        opacity: {
          value: props.alpha,
        },
        alpha: this.alpha,
      },
      depthTest: true,
      depthWrite: true,
      transparent: true,
      side: THREE.DoubleSide,
      vertexShader,
      fragmentShader,
    });
  };

  setupMesh = props => {
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.renderOrder = props.renderOrder;
    this.mesh.traverse(child => {
      child.renderOrder = props.renderOrder;
    });
    this.add(this.mesh);
  };

  getMesh = () => {
    return this.mesh;
  };
}



// WEBPACK FOOTER //
// ./src/gfx/Dot.js